module.exports = __webpack_public_path__ + "img/icon_dh.e4d85578.png";